/* eslint-disable */
export default {
  copy: 'Kopiëren',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
